import _ from 'lodash';
import { GOAL_TYPES } from 'constantsBase';
import { CONVERSION_BASED_GOALS } from 'containers/StrategyWizard/steps/GoalSelection/constants';

export const CONTAINER_NAME = 'Strategies Information';

export enum ActionTypes {
  edit = 'edit',
  delete = 'delete',
}

export const goalsForBulkCreate = [
  GOAL_TYPES.cpc,
  GOAL_TYPES.cpcv,
  GOAL_TYPES.cpm,
  GOAL_TYPES.ctr,
  GOAL_TYPES.completionRate,
  GOAL_TYPES.vcpcv,
  GOAL_TYPES.vcpm,
  GOAL_TYPES.vcrYoutube,
  GOAL_TYPES.cpvYoutube,
  GOAL_TYPES.impValuePerCost,
  GOAL_TYPES.impValuePerImp,
  ..._.map(CONVERSION_BASED_GOALS, (goalKey) => GOAL_TYPES[goalKey]),
];
